// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + "about" + "." + "7c8dd0e1" + ".js";
};